import React, { useEffect } from 'react'
import styles from './ManagerHeader.module.scss'
import HeaderLogo from '../../ui/headerLogo/HeaderLogo'
import { ManagerProfileDrop } from '../../../menu/dropdown/managerProfile/managerProfile'
import { NavLink, useNavigate } from 'react-router-dom'
import { routersPath } from '../../../router/routes-path'
import { getTestsCount } from '../../../store/tests/thunk'
import { useAppDispatch } from '../../../store/hooks'
import { useTestsCountSelector } from '../../../store/selectors/tests'
import {
  IconAngleDown,
  IconClipboardEdit,
  IconLightbulb,
  IconMoon,
  IconPrint,
  IconReceiptText,
} from '../../../utils/icons'
import { Space, Switch } from 'antd'
import { useThemeSelector } from '../../../store/selectors/theme'
import { setTheme } from '../../../store/theme/reducer'
import { useChatToken, useCrmPermission } from '../../../store/selectors/crmInfo'
import DropdownUI from '../../ui/DropDownUI/DropdownUi'
import { updateChatScript } from '../../../utils/chat'
import { getLinks } from '../../../store/links/thunk'

const ManagerHeader: React.FC = () => {
  const dispatch = useAppDispatch()
  const testsCount = useTestsCountSelector()
  const theme = useThemeSelector()
  const permissions = useCrmPermission()
  const chatToken = useChatToken()

  useEffect(() => {
    dispatch(getTestsCount()).then()
    void dispatch(getLinks())
  }, [])

  useEffect(() => {
    updateChatScript(chatToken)
  }, [chatToken])

  const navigate = useNavigate()

  const onChange = (checked: boolean) => {
    dispatch(setTheme({ theme: checked ? 'dark' : 'light' }))
  }

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <span className={styles.logo}>
          <HeaderLogo />
        </span>

        <div className={styles.actions}>
          <div className={styles.switcher}>
            <Switch
              defaultChecked={theme === 'dark'}
              onChange={onChange}
              checkedChildren={<IconMoon width='14' height='14' fill='var(--color-main)' />}
              unCheckedChildren={<IconLightbulb width='16' height='16' fill='var(--color-main)' />}
            />
          </div>

          {permissions.scripts && (
            <div className={styles.btnWrapper}>
              <div className={styles.btn} onClick={() => navigate(routersPath.MANAGER_SCRIPTS)}>
                <IconReceiptText width='22' height='22' fill='var(--color-main)' />
                Мои скрипты
              </div>
            </div>
          )}

          {permissions.generator && (
            <div className={styles.btnWrapper}>
              <DropdownUI
                menu={{
                  items: [
                    {
                      key: routersPath.DOC_GEN,
                      label: (
                        <NavLink to={routersPath.DOC_GEN}>
                          Генератор документов <b>v.1</b>
                        </NavLink>
                      ),
                      icon: <IconPrint width='22' height='22' fill='var(--color-main)' />,
                    },
                    {
                      key: routersPath.NEW_DOC_GEN,
                      label: (
                        <NavLink to={routersPath.NEW_DOC_GEN}>
                          Генератор документов <b>v.2</b>
                        </NavLink>
                      ),
                      icon: <IconPrint width='22' height='22' fill='var(--color-main)' />,
                    },
                  ],
                }}
              >
                <Space>
                  <IconPrint width='22' height='22' fill='var(--color-main)' />
                  Генератор документов
                </Space>
              </DropdownUI>
            </div>
          )}

          <div className={styles.dropdown}>
            <ManagerProfileDrop />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ManagerHeader
